import { FormCheckbox, FormCheckboxGroup, Typography } from 'omakase';
import { InputHTMLAttributes } from 'react';
import { QuestionCheckboxResponse } from '@tock/shared/utils/questionUtils';
import { QuestionOptionalTextField } from 'forms/previsit-questions/QuestionOptionalTextField';
import { core } from '@tock/coretypes';
import { getOptionsFromQuestion } from 'forms/previsit-questions/questionOptions';
import { useField } from 'formik';

interface Props {
  name: string;
  question: core.TicketTypeQuestion;
}

/**
 * FormCheckboxGroup control with a label and configurable free form text
 * entry
 */
export const QuestionCheckboxGroupField = ({ name, question }: Props) => {
  const [, { value }] = useField<QuestionCheckboxResponse>(name);
  const options = getOptionsFromQuestion(question);

  if (!value) {
    return null;
  }

  return (
    <div data-testid="pre-visit-question">
      <Typography variant="body02" data-testid="pre-visit-question-label">
        {question.text}
      </Typography>
      <FormCheckboxGroup
        label={question.text}
        disclosureMode="static"
        name={`${name}.value`}
        hideLabel
      >
        {options.map((option) => (
          <FormCheckbox
            name={`${name}.value`}
            value={option.text}
            label={option.text}
            key={option.text}
            inputProps={
              {
                'data-testid': 'pre-visit-question-checkbox',
              } as InputHTMLAttributes<HTMLInputElement>
            }
          />
        ))}
      </FormCheckboxGroup>
      <QuestionOptionalTextField name={name} question={question} value={value.value} />
    </div>
  );
};
